<template>
    <v-expansion-panel class="price-filter elevation-0" v-model="expansionPanelModel" expand>
        <v-expansion-panel-content expand-icon="keyboard_arrow_right" class="transparent">
            <template v-slot:header>
                <v-layout row wrap align-center ma-0>
                    <v-flex xs2>
                        <v-icon>euro</v-icon>
                    </v-flex>
                    <v-flex xs10>
                        <div class="body-2">{{ 'Price' | translation }}</div>
                    </v-flex>
                </v-layout>
            </template>

            <v-card flat class="transparent">
                <v-card-text class="py-1 px-3">
                    <v-range-slider
                        class="ma-0"
                        v-model="price"
                        :min="0"
                        :max="searchFilterPriceMax"
                        :step="1"
                        @change="applyPriceFilter"
                        hide-details
                    >
                    </v-range-slider>
                    <v-layout row wrap my-0>
                        <v-flex xs6 pa-0>
                            <span>{{priceMin | currency}}</span>
                        </v-flex>
                        <v-flex xs6 pa-0 justify-right text-xs-right>
                            <span>{{priceMax | currency}}</span>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<style lang="stylus">
    @import '~vuetify/src/stylus/settings/_variables.styl';

    @media(max-width: $grid-breakpoints.md) {
        .price-filter .v-expansion-panel__header {
            display: none
        }
    }
</style>

<script>
    import {mapGetters, mapState} from 'vuex';
    import SearchResults from './SearchResults';
    import Vue from 'vue';

    export default {
        name: 'PriceFilter',
        props: {
            value: {},
        },
        data() {
            return {
                expanded: null,
                lastFilterMinPrice: 0,
                lastFilterMaxPrice: 0,
                price: [
                    0,
                    0,
                ],
            };
        },
        mounted() {
            this.lastFilterMinPrice = this.$router.currentRoute.params.priceRangeMin || 0;
            this.lastFilterMaxPrice = this.$router.currentRoute.params.priceRangeMax || this.searchFilterPriceMax;
            this.price = [this.lastFilterMinPrice, this.lastFilterMaxPrice];
            this.emitValue();
        },
        computed: {
            ...mapState(SearchResults.name, [
                'loading',
            ]),
            ...mapGetters(SearchResults.name, [
                'searchConfig',
            ]),
            expansionPanelModel: {
                get() {
                    if (this.expanded !== null) {
                        return this.expanded;
                    } else {
                        return [
                            this.$vuetify.breakpoint.smAndDown ||
                            this.lastFilterMinPrice !== undefined ||
                            this.lastFilterMaxPrice !== undefined
                        ];
                    }
                },
                set(val) {
                    this.expanded = val;
                },
            },
            priceMin() {
                return this.price[0];
            },
            priceMax() {
                return this.price[1];
            },
            filterMinPrice() {
                return this.priceMin > 0 ? this.priceMin : null;
            },
            filterMaxPrice() {
                return this.priceMax < this.searchFilterPriceMax ? this.priceMax : null;
            },
            searchFilterPriceMax() {
                return this.searchConfig('searchFilterPriceMax');
            },
        },
        methods: {
            applyPriceFilter() {
                let params = {};
                if (this.priceMin != this.$router.currentRoute.params.priceRangeMin) {
                    params['priceRangeMin'] = this.filterMinPrice;
                }
                if (this.priceMax != this.$router.currentRoute.params.priceRangeMax) {
                    params['priceRangeMax'] = this.filterMaxPrice;
                }
                if (Object.values(params).length > 0) {
                    this.$router.push({
                        path: this.$search.getSearchRouteParams(params, false, true)
                    });
                }

                this.emitValue();
            },
            emitValue() {
                this.$emit('input', {
                    priceMin: this.filterMinPrice,
                    priceMax: this.filterMaxPrice,
                });
            },
        },
    };
</script>